module.exports = __webpack_public_path__ + "img/uk-lung-cancer-female.5311f4bd.png";